export default {"src":"/_next/static/media/heelio-mini.03a86d30.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};